export default "__VITE_ASSET__6xgab1nm__"